import { BrickContext } from 'olympe';

export const Application = '0113030000000aca1100';
export const MATOMO_SCRIPT_ID = 'matomo-tracking-code';
export const MATOMO_ENABLED_FLAG = 'matomo-is-enabled';

/**
 * @return {boolean}
 */
export function isMatomoTrackingInserted() {
    return document.querySelector(`script#${MATOMO_SCRIPT_ID}`)
}

/**
 * Check whether the tracking with Matomo has been enabled or not
 * Can return `undefined` if the tracking code brick has not been called
 * 
 * @return {boolean | undefined}
 */
export function isMatomoTrackingEnabled($) {
    const applicationContext = getApplicationContext($);
    return applicationContext.get(MATOMO_ENABLED_FLAG) ?? undefined;
}

/**
 * 
 * @param {BrickContext} $ 
 * @param {boolean} enabled 
 */
export function setMatomoTrackingEnabled($, enabled) {
    if (typeof enabled !== 'boolean') {
        throw new Error('Invalid enabled argument, must be a boolean');
    }
    const applicationContext = getApplicationContext($);
    applicationContext.set(MATOMO_ENABLED_FLAG, enabled);
}

function getApplicationContext($) {
    return $.getClosest({modelTag: Application});
}
